import classnames from 'classnames';
import * as React from 'react';

// Internal
import { Image } from '@src/components/Image';
import { DEFAULT_SAL_PROPS } from '@src/config/sal';

// Styles
import styles from './styles.module.css';

export interface QuoteProps {
  author?: string;
  color?: 'blue' | 'green';
  delay?: number;
  logo?: {
    alt?: string;
    fileName: string;
    maxWidth?: number;
  };
  quote: string;
  sectionNumber?: string;
}

const Quote: React.FC<QuoteProps> = (props) => {
  const { author, color = 'green', delay, logo, quote } = props;

  // Setup
  const alt = logo?.alt || '';
  const fileName = logo?.fileName || '';
  const maxWidth = logo?.maxWidth;

  // Styles
  const classes = classnames(styles.component, styles[color]);
  const classesTriangle = classnames(styles.triangle, styles[color]);

  return (
    <blockquote
      {...DEFAULT_SAL_PROPS}
      data-sal-delay={delay}
      className={classes}
    >
      <p>{quote}</p>
      <footer>
        {logo && <Image alt={alt} fileName={fileName} maxWidth={maxWidth} />}
        {author && <p className="text-sm font-bold mt-3">{author}</p>}
      </footer>
      <div className={classesTriangle} />
    </blockquote>
  );
};

export { Quote };
